import API_CLIENT from "../../utils/Api";

export async function GetBoxes() {
  return await API_CLIENT.get(`/boxes`);
}
